import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule,HTTP_INTERCEPTORS  } from '@angular/common/http';
import { SpinnerInterceptor } from './core/interceptors/spinner.interceptor';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SharedModule } from './theme/shared/shared.module';
import { ReactiveFormsModule } from '@angular/forms';  // Importar ReactiveFormsModule
import { CommonModule } from '@angular/common';  // Importar CommonModul
import { ToastComponent } from './toast/toast.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AuthInterceptor } from './auth.interceptor';

@NgModule({
  declarations: [AppComponent,ToastComponent],
  imports: [BrowserAnimationsModule, ReactiveFormsModule,
    CommonModule,HttpClientModule,BrowserModule, AppRoutingModule, SharedModule],
  bootstrap: [AppComponent],
  providers: [
    { 
      provide: HTTP_INTERCEPTORS, 
      useClass: AuthInterceptor, 
      multi: true 
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: SpinnerInterceptor,
      multi: true
    }
  ],
})
export class AppModule {}
